import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

export const initialState = {
  currentClubsCounts: {},
  currentClueNumAttempts: 0,
  currentFriendScore: 0,
  friendsToScore: {}, // friendId to their saved score (updated once friend completes)

  questionCount: 0,
  questionsCorrect: 0,
};

const score = (state = initialState, { gameId, payload, type }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.INCREMENT_CORRECT_COUNT:
      return {
        ...state,
        currentFriendScore: state.currentFriendScore + 1,
        questionsCorrect: state.questionsCorrect + 1,
      };

    case REDUX_ACTIONS.GO_TO_NEXT_CLUE:
      return {
        ...state,
        currentClueNumAttempts: 0,
      };

    case REDUX_ACTIONS.INCREMENT_CLUB_COUNT:
      return {
        ...state,
        currentClubsCounts: {
          ...state.currentClubsCounts,
          [payload]: state.currentClubsCounts[payload] + 1 || 1,
        },
      };

    case REDUX_ACTIONS.INCREMENT_CLUE_NUM_ATTEMPTS:
      return {
        ...state,
        currentClueNumAttempts: state.currentClueNumAttempts + 1,
      };

    case REDUX_ACTIONS.INCREMENT_QUESTION_COUNT:
      return {
        ...state,
        questionCount: state.questionCount + 1,
      };

    case REDUX_ACTIONS.SELECT_LEVEL:
      return {
        ...state,
        questionCount: 0,
        questionsCorrect: 0,
      };

    case REDUX_ACTIONS.RESET_CURRENT_SCORE:
      return {
        ...state,
        currentClubsCounts: initialState.currentClubsCounts,
        currentClueNumAttempts: initialState.currentClueNumAttempts,
        currentFriendScore: initialState.currentFriendScore,
      };

    case REDUX_ACTIONS.RESET_FRIENDS_TO_SCORE:
      return {
        ...state,
        friendsToScore: initialState.friendsToScore,
      };

    case REDUX_ACTIONS.SET_FRIEND_SCORE:
      return {
        ...state,
        friendsToScore: { ...state.friendsToScore, [payload.friendId]: state.currentFriendScore },
      };

    case REDUX_ACTIONS.QUICK_ROUND: {
      const questionsCorrect = payload.pass ? payload.numQuestions : 0;
      return {
        ...state,
        questionCount: payload.numQuestions,
        questionsCorrect,
      };
    }

    default:
      return state;
  }
};

export default score;
